import React from 'react';

import { StatTile } from '../../../core/ui';
import { useTranslation } from '../../../core/context/TranslationContext';

import { formatTry } from '../format';
import styles from './SpendingReports.module.css';

/**
 * Headline numbers of the combined report. The total already counts every
 * purchase once; the other tiles only say where the data came from.
 */
export default function SpendingSummary({ report }) {
  const { t } = useTranslation();
  const { sources } = report;
  const months = report.months.length || 1;

  return (
    <div className={styles.summary}>
      <StatTile
        label={t('budget.spendingTotal')}
        value={formatTry(report.total)}
        hint={t('budget.spendingMonthlyAverage', { amount: formatTry(Number(report.total) / months) })}
      />
      <StatTile
        label={t('budget.spendingByCard')}
        value={formatTry(sources.cardTotal)}
        hint={t('budget.spendingCardHint', { count: sources.cardCount, matched: sources.cardWithReceiptCount })}
      />
      <StatTile
        label={t('budget.spendingReceiptOnly')}
        value={formatTry(sources.receiptOnlyTotal)}
        hint={t('budget.spendingReceiptOnlyHint', { count: sources.receiptOnlyCount })}
      />
    </div>
  );
}
